// extracted by mini-css-extract-plugin
export default {"error":"styles_error__r8Q4l","warning":"styles_warning__7uiec","success":"styles_success__FTosj","icon":"styles_icon__0k3D0"};